export const supportedLocales = ['nl', 'en'] as const
export type SupportedLocale = typeof supportedLocales[number]